export const creditCardContentBox = {
    showLockAndUnlockNavigation: true,
    showDisplayPinNavigation: true,
    showPayUpNavigation: true,
    cardMeter: {
        addAuthorizedAmountToValue: true,
    },
    cardLegend: {
        showBalanceAsOutstandingAmount: true,
    },
};
